module.exports = __webpack_public_path__ + "img/GP.55df0a2e.svg";